
import App, { store as reduxStore } from './App'

export const store = reduxStore
export default App
